export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कल"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["चैट"])}
}